const listPriceFormatter = new Intl.NumberFormat();
const dateFormatter = new Intl.DateTimeFormat();

class SignalInfo {
  constructor([
    internalId,
    menuPath,
    signalName,
    signalProvider,
    category,
    performance,
    coverage,
    capacity,
    uniqueness,
    correlationToAllSignals,
    correlationWithinCategory,
    countries,
    delivery,
    goLive,
    listPrice,
    performanceBasedFeesAvailable,
    whitePaperLink,
    logoLink,
    subscriptionOptionsId,
  ]) {
    this.internalId = internalId;
    this.menuPath = menuPath;
    this.signalName = signalName;
    this.signalProvider = signalProvider;
    this.category = category;
    this.performance = performance;
    this.coverage = coverage;
    this.capacity = capacity;
    this.uniqueness = uniqueness;
    this.correlationToAllSignals = correlationToAllSignals;
    this.correlationWithinCategory = correlationWithinCategory;
    this.countries = countries;
    this.delivery = delivery;
    this.performanceBasedFeesAvailable = performanceBasedFeesAvailable;
    this.whitePaperLink = whitePaperLink;
    this.logoLink = logoLink;
    this.subscriptionOptionsId = subscriptionOptionsId;

    // try to parse the date from US format
    const [month, day, year] = goLive.split("/");
    if (year) {
      this.goLive = dateFormatter.format(new Date(year, month, day));
    } else {
      // unparseable, then just take the literal value
      this.goLive = goLive;
    }

    // if the listPrice is a number, format it as a dollar amount
    this.listPrice = Number.isNaN(Number.parseFloat(listPrice))
      ? listPrice
      : `$${listPriceFormatter.format(listPrice)}`;
  }
}

export default SignalInfo;
